module.exports = __webpack_public_path__ + "img/good1.3209d4a5.png";